import React, { Component } from "react";
import "./ReduceDashCommand.css";
import "../Styles/SvgCommand.css";

const ReduceDashCommand = (props) => {
  return (
    <svg
      className="svg"
      className={
        props.isStandard & props.isShow
          ? "svg"
          : props.isShow
          ? "reduceDash"
          : "isClose"
      }
    >
      <rect x="5" y="8" width="12" height="0.4" />
    </svg>
  );
};

export default ReduceDashCommand;
